import visitorsPathname from 'components/routes/firstLevelRoutes/Visitors/pathname'
import { scriptPath } from 'components/routes/Connect/Script'

export default [
  {label: 'Leads', path: visitorsPathname, icon: 'person', color: '#253342'},
  {label: 'Analytics Settings', path: scriptPath, icon: 'bar-chart', color: '#253342'},
  // {label: 'Billing', path: '/settings/billing', icon: 'placeholder-1', color: '#253342'},
  {label: 'Settings', path: '/settings/user', icon: 'config', color: '#253342'},
  // {label: 'Contacts', path: '/contacts', icon: 'person', color: '#253342'},
  // {label: 'Email Templates', path: '/email-templates', icon: 'mail-opened', color: '#253342'},
  // {label: 'Flows', path: '/flows', icon: 'flows', color: '#253342'},
];
